import { render, staticRenderFns } from "./BookEditor.vue?vue&type=template&id=95208d26&scoped=true"
import script from "./BookEditor.vue?vue&type=script&lang=js"
export * from "./BookEditor.vue?vue&type=script&lang=js"
import style0 from "./BookEditor.vue?vue&type=style&index=0&id=95208d26&prod&lang=scss&scoped=true"
import style1 from "./BookEditor.vue?vue&type=style&index=1&id=95208d26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95208d26",
  null
  
)

export default component.exports